import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=ae165e36&scoped=true"
var script = {}
import style0 from "./Loader.vue?vue&type=style&index=0&id=ae165e36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae165e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae165e36')) {
      api.createRecord('ae165e36', component.options)
    } else {
      api.reload('ae165e36', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=ae165e36&scoped=true", function () {
      api.rerender('ae165e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/UIComponents/Loader.vue"
export default component.exports